import { createMuiTheme } from '@material-ui/core/styles';

export const findBobTheme = {
    palette: {
        type: 'light',
        primary: {
            main: '#1396e2',
        },
        secondary: {
            main: '#073855',
        },
        accent: {
            main: '#1396e2',
        },
        highlight: {
            main: '#5a5a5a',
        },
        graph: ['#073855', '#1396e2', '#5a5a5a', '#282B3E', '#ec008c', '#68217a', '#00bcf2', '#00b294', '#00188f', '#ff8c00'],
    },
    props: {
        MuiButton: {
            size: 'small',
            color: 'primary',
        },
        MuiButtonGroup: {
            size: 'small',
        },
        MuiCheckbox: {
            size: 'small',
        },
        MuiFab: {
            size: 'small',
        },
        MuiFormControl: {
            margin: 'dense',
            size: 'small',
        },
        MuiFormHelperText: {
            margin: 'dense',
        },
        MuiIconButton: {
            size: 'small',
        },
        MuiInputBase: {
            margin: 'dense',
        },
        MuiInputLabel: {
            margin: 'dense',
        },
        MuiRadio: {
            size: 'small',
        },
        MuiSwitch: {
            size: 'small',
        },
        MuiTextField: {
            margin: 'dense',
            size: 'small',
        },
        MuiInputSlider: {
            color: 'secondary'
        },
        InputSlider: {
            color: 'secondary'
        },
    },
};

export default findBobTheme;